import script from "./LoadingScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&setup=true&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=eea2f626&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eea2f626"]])

export default __exports__